<template>
  <div class="heatmap-container">
    <div class="heatmap">
      <div
        v-for="(day, index) in days"
        :key="index"
        class="day-column"
        :style="{ '--bar-h': getBarHeight(day.score), '--bar-w': getBarWidth(day.score) }"
      >
        <div
          v-if="isMobile"
          class="day-label"
        >
          {{ day.label }}
        </div>
        <div
          v-if="isMobile"
          class="bar-wrapper"
        >
          <div class="bar" />
        </div>
        <div>
          <div
            v-if="!isMobile"
            class="bar-wrapper"
          >
            <div class="bar" />
          </div>
          <div
            v-if="!isMobile"
            class="day-label"
          >
            {{ day.label }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActivityHeatmap',
  props: {
    activities: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      days: [
        { label: 'Mon', score: 0 },
        { label: 'Tue', score: 0 },
        { label: 'Wed', score: 0 },
        { label: 'Thu', score: 0 },
        { label: 'Fri', score: 0 },
        { label: 'Sat', score: 0 },
        { label: 'Sun', score: 0 }
      ]
    }
  },
  computed: {
      maxScore() {
        const scores = this.activities.map(activity => activity.count);
        if (scores.length === 0) return 1;
        return Math.max(...scores);
        },
        isMobile() {
        return window.innerWidth <= 599;
      }
    },
    watch: {
    activities: {
        handler(newActivities) {
            const today = new Date();
            const startOfWeek = new Date(today);
            this.days.forEach((day, index) => {
                const activityDate = new Date(startOfWeek);
                activityDate.setDate(activityDate.getDate() - index);
                day.label = activityDate.toLocaleDateString('en-US', { weekday: 'short' });
                day.score = 0;
            });

            newActivities.forEach((activity, index) => {
                if (index < this.days.length) {
                    this.days[index].score = activity.count
                }
            })
            this.days.reverse();
    },
    immediate: true
}
},
methods: {
  getBarHeight(score) {
    if (this.maxScore === 0) return '4px'
    return `${Math.max((score / this.maxScore) * 80, 4)}px`
  },
  getBarWidth(score) {
    if (this.maxScore === 0) return '5%'
    return `${Math.max((score / this.maxScore) * 100, 5)}%`
  },
},
}
</script>

<style scoped>
.heatmap-container {
  padding: clamp(10px, 2vw, 20px);
  background-color: var(--color-surface);
  border-radius: var(--radius-md);
  width: 100%;
}

.heatmap {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: clamp(4px, 1vw, 8px);
  width: 400px;
  margin: 0 auto;
}

.day-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  flex: 1;
}

.bar-wrapper {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: flex-end;
}

.bar {
  width: 50px;
  height: var(--bar-h, 4px);
  min-height: 4px;
  background: var(--gradient-aurora);
  border-radius: var(--radius-sm) var(--radius-sm) 0 0;
  transition: height 0.4s ease;
}

.day-label {
  font-size: clamp(10px, 1.5vw, 10px);
  color: var(--color-text-secondary);
  white-space: nowrap;
  font-family: var(--font-family);
}

@media (max-width: 599px) {
  .heatmap {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    width: 200px;
  }
  
  .day-column {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    height: 24px;
    padding-left: 80px;
    padding-right: 40px;
  }

  .bar-wrapper {
    flex: 1;
    height: 100%;
    align-items: center;
  }

  .bar {
    width: var(--bar-h, 5%);
    min-height: unset;
    min-width: 4px;
    background: var(--gradient-aurora);
    border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
    transition: width 0.4s ease;
    height: 20px
  }

  .day-label {
    font-size: 12px;
    min-width: 36px;
    text-align: right;
    margin-bottom: 0;
    margin-left: -50px;

  }
}
</style>